/*
 * Fetch the real Sleep Music by Sleep Sounds app icon from Apple's public
 * iTunes lookup for App Store ID 6471406616. The existing brand mark stays as
 * a fallback if Apple is unavailable. This does not track visitors.
 */
(function () {
  'use strict';
  var APP_ID = 6471406616;
  var API = 'https://itunes.apple.com/lookup?id=' + APP_ID + '&country=us';
  function iconUrl(payload) {
    if (!payload || !Array.isArray(payload.results)) return null;
    var item = payload.results.find(function (result) {
      return Number(result.trackId) === APP_ID;
    });
    if (!item) return null;
    var candidate = item.artworkUrl512 || item.artworkUrl100;
    if (typeof candidate !== 'string' || !/^https:\/\/(?:is\d+(?:-ssl)?\.mzstatic\.com|a\d+\.mzstatic\.com)\//i.test(candidate)) return null;
    return candidate;
  }
  function display(payload) {
    var url = iconUrl(payload);
    if (!url) return;
    document.querySelectorAll('[data-ss-sleep-music-app-icon]').forEach(function (img) {
      var preloader = new Image();
      preloader.onload = function () {
        if (!img.isConnected) return;
        img.src = url;
        img.hidden = false;
        img.removeAttribute('data-ss-sleep-music-app-icon');
        var parent = img.closest('.ss-sma-brand__mark');
        if (parent) parent.classList.add('is-loaded');
      };
      preloader.src = url;
    });
  }
  function loadIcon() {
    if (!document.querySelector('[data-ss-sleep-music-app-icon]')) return;
    fetch(API, {mode:'cors',cache:'force-cache'})
      .then(function (res) {if (!res.ok) throw new Error('Apple lookup failed');return res.json();})
      .then(function (payload) {
        if (!iconUrl(payload)) throw new Error('No matching app artwork');
        display(payload);
      })
      .catch(function () {
        var callback = 'ssSleepMusicIcon_' + APP_ID;
        if (window[callback]) return;
        var tag = document.createElement('script');
        function cleanup(){
          tag.remove();
          try {delete window[callback];} catch (err) {window[callback] = undefined;}
        }
        window[callback] = function (data) {display(data); cleanup();};
        tag.onerror = cleanup;
        tag.src = API + '&callback=' + encodeURIComponent(callback);
        document.head.appendChild(tag);
      });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadIcon);
  } else {
    loadIcon();
  }
  document.addEventListener('shopify:section:load', loadIcon);
})();
